import { Controller, useFormContext } from "react-hook-form";
import { useRecoilValue } from "recoil";
import CheckBoxHookForm_2 from "../../../../components/CheckBoxHookForm_2";
import { useEffect, useState, useMemo } from "react";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { scorecardAddState, scorecardEditState } from "../atoms/atoms";
import SelectHookFormSingle from "../../../../components/SelectHookFormSingle";
import TextInputLabelHookForm from "../../../../components/TextInputLabelHookForm";
import { useScorecardStatus } from "../hooks/useScorecardStatus";
import { useScorecardType } from "../hooks/useScorecardType";
import { useScorecardArea } from "../hooks/useScorecardArea";
import { useDescriptiveGroup } from "../hooks/useScorecardDescriptiveGroup";
import { useScorecardException } from "../hooks/useScorecardException";
import { useScorecardCloseReason } from "../hooks/useScorecardCloseReason";
import { useScorecardGeneralGroup } from "../hooks/useScorecardGeneralGroup";
import { useSFGetOffice } from "../../OfficeSettings/hooks/useSFGetOffice";
import { useEmployees } from "../../Employees/Confie/hooks/useEmployees";
import { IScoreCardDetails } from "../types";
import NumericInputLabel from "../../../../components/NumericInputLabel";
import { useGetActionRequired } from "../hooks/useGetActionRequired";
import useScorecardDispute from "../hooks/useScorecardDispute";
import SelectHookFormVirtualizeScorecard from "../../../../components/SelectHookFormVirtualizeScorecard";
import SelectInputVirtualize from "../../../../components/SelectInputVirtualize";

interface ScoreCardDetailsProps {
  rowForEdit: IScoreCardDetails | undefined;
}
const ScoreCardDetails: React.FC<ScoreCardDetailsProps> = ({ rowForEdit }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const isAddState = useRecoilValue(scorecardAddState);
  const isEditState = useRecoilValue(scorecardEditState);
  const formMethods = useFormContext();
  const user = useRecoilValue(accountAtom);
  const [empOfficeCode, setEmpOfficeCode] = useState("");
  //DropDown Options
  const { data: agencies } = useSFGetOffice();
  const sfOfficeNameOpt = agencies
    ?.filter(
      (y) =>
        y.officeCode !== null &&
        y.officeCode !== undefined &&
        y.officeCode !== ""
    )
    .map((x) => {
      return {
        officeId: x.officeId,
        businessOperation: x.businessOperation,
        id: x.officeCode,
        value: x.officeName,
        label: x.officeName,
      };
    });

  // Use useMemo to ensure that the uniqueIds Set is recreated only when data changes
  const uniqueIds = useMemo(() => new Set(), sfOfficeNameOpt);

  const accountOpts = sfOfficeNameOpt
    ?.map((x) => {
      // Check if the id is already in the Set
      if (uniqueIds.has(x.officeId)) {
        // If it's a duplicate, skip it
        return null;
      }
      // Add the id to the Set to mark it as processed
      uniqueIds.add(x.officeId);

      return {
        officeId: x.officeId,
        businessOperation: x.businessOperation,
        id: x.id,
        value: x.value,
        label: x.label,
      };
    })
    .filter(Boolean);

  const { data: employees, isLoading: empLoading } = useEmployees();

  const employeeList = employees?.map(
    (x: {
      employeenumber: number;
      employeeId: number;
      fullname: string;
      email: string;
      status: string;
      reportsToFullname: string;
      officeName: string;
      officecode: string;
      firstname: string;
      middlename: string;
      lastname: string;
    }) => {
      return {
        value: x.employeeId,
        label:
          x.firstname +
          (x.middlename ? " " + x.middlename + " " : " ") +
          x.lastname,
        email: x.email,
        status: x.status,
        manager: x.reportsToFullname,
        officeCode: x.officecode,
        officeName: x.officeName,
        fullName: x.fullname,
      };
    }
  );

  const franchiseEmployee = employees
    ?.filter((x) => x.employeeTypeName === "Franchise")
    ?.map(
      (x: {
        employeenumber: number;
        employeeId: number;
        fullname: string;
        email: string;
        status: string;
        reportsToFullname: string;
        officeName: string;
        officecode: string;
        firstname: string;
        middlename: string;
        lastname: string;
      }) => {
        return {
          value: x.employeeId,
          label:
            x.firstname +
            (x.middlename ? " " + x.middlename + " " : " ") +
            x.lastname,
          email: x.email,
          status: x.status,
          manager: x.reportsToFullname,
          officeCode: x.officecode,
          officeName: x.officeName,
          fullName: x.fullname,
        };
      }
    );

  const confieEmployee = employees
    ?.filter((x) => x.employeeTypeName !== "Franchise")
    ?.map(
      (x: {
        employeenumber: number;
        employeeId: number;
        fullname: string;
        email: string;
        status: string;
        reportsToFullname: string;
        officeName: string;
        officecode: string;
        firstname: string;
        middlename: string;
        lastname: string;
      }) => {
        return {
          value: x.employeeId,
          label:
            x.firstname +
            (x.middlename ? " " + x.middlename + " " : " ") +
            x.lastname,
          email: x.email,
          status: x.status,
          manager: x.reportsToFullname,
          officeCode: x.officecode,
          officeName: x.officeName,
          fullName: x.fullname,
        };
      }
    );
  const { data: scorecardDispute } = useScorecardDispute();
  const disputeOpts = scorecardDispute?.data?.map((x) => {
    return {
      id: x.disputeId,
      value: x.disputeId,
      label: x.disputeName,
    };
  });
  const isDisputeRequired = formMethods
    .watch("status")
    ?.toLowerCase()
    ?.includes("closed");
  const isContact = formMethods.watch("contact") !== undefined;
  useEffect(() => {
    if (isAddState) formMethods.setValue("contactOwner", user.userName);
    if (
      isEditState &&
      rowForEdit?.actionRequiredOrNotificationC === "Notification Only"
    ) {
      setIsNoficationOnly(true);
    }
    if (isEditState && empOfficeCode == "") {
      setEmpOfficeCode(rowForEdit?.empOfficeCode ?? "");
    }
    if (isEditState && isContact) {
      formMethods.setValue("account", rowForEdit?.account);
    }
    if (isEditState && rowForEdit?.disputeC !== "") {
      const dispute = disputeOpts?.filter((x) =>
        x.label?.includes(rowForEdit?.disputeC)
      );
      if (dispute !== undefined) {
        formMethods.setValue("disputeId", dispute[0]?.value);
      }
    }
  }, []);

  const { data: statusScorecard, isLoading: isStatusLoading } =
    useScorecardStatus();
  const statusOpts = statusScorecard?.data?.map((x) => {
    return {
      label: x.status,
      value: x.id,
      statusId: x.id,
    };
  });
  const { data: typeScorecard, isLoading: isTypesLoading } = useScorecardType();
  const typeOpts = typeScorecard?.data?.map((x) => {
    return {
      label: x.scoreCardTypeName,
      value: x.scoreCardTypeId,
    };
  });

  const { data: descriptiveGroup, isLoading: isDescGroupLoading } =
    useDescriptiveGroup();
  const descGroupOpts = descriptiveGroup?.data
    ?.filter((y) => y.generalGroupId == formMethods?.watch("generalGroupId"))
    .map((x) => {
      return {
        label: x.descriptiveGroup1,
        value: x.id,
        genId: x.generalGroupId,
        descId: x.id,
      };
    });

  const { data: AreaScorecard, isLoading: isAreaScorecardLoading } =
    useScorecardArea();
  const scoreCardAreaOpts = AreaScorecard?.data
    ?.filter(
      (a) => a.descriptiveGroupId == formMethods?.watch("descriptiveGroupId")
    )
    .map((x) => {
      return {
        label: x.scorecardArea1,
        value: x.id,
      };
    });
  const { data: closeReason } = useScorecardCloseReason();
  const closeReasonFilteredpOpts = closeReason?.data
    ?.filter((b) =>
      b.statusId.includes(formMethods?.watch("statusId")?.toString())
    )
    .map((x) => {
      return {
        label: x.closeReason1,
        value: x.closeReason1,
        statusId: x.statusId,
      };
    });

  const currentCloseReason = closeReason?.data?.filter(
    (a) => a.closeReason1 == rowForEdit?.closeReasonC
  )[0]?.statusId;

  const closeReasonpOpts = closeReason?.data
    ?.filter((a) => a.statusId?.includes(currentCloseReason))
    .map((x) => {
      return {
        label: x.closeReason1,
        value: x.closeReason1,
        statusId: x.statusId,
      };
    });

  const { data: genGroupScorecard, isLoading: isGenGroupLoading } =
    useScorecardGeneralGroup();
  const generalGroupOpts = genGroupScorecard?.data?.map((x) => {
    return {
      label: x.generalGroup1,
      value: x.id,
    };
  });
  const { data: exceptionScorecard } = useScorecardException();
  const exceptionFilteredOpts = exceptionScorecard?.data
    ?.filter(
      (b) =>
        b.scorecardAreaId === formMethods?.watch("scorecardAreaId")?.toString()
    )
    .map((x) => {
      return {
        label: x.exception,
        value: x.exception,
        genId: x.scorecardAreaId,
      };
    });

  const currentScorecardId = AreaScorecard?.data?.filter(
    (a) => a.scorecardArea1 == formMethods?.watch("scorecardAreaC")
  )[0]?.id;

  const exceptionOpts = exceptionScorecard?.data
    ?.filter((a) => a.scorecardAreaId == currentScorecardId)
    .map((x) => {
      return {
        label: x.exception,
        value: x.exception,
        genId: x.scorecardAreaId,
      };
    });

  const { data: GetActionRequired, isLoading: ActionRequiredLoading } =
    useGetActionRequired();
  const actionRequiredOpts = GetActionRequired?.data?.map(
    (x: { id: number; actionReq: string }) => {
      return {
        id: x.id,
        value: x.id,
        label: x.actionReq,
      };
    }
  );

  const fullPayOpts = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];

  const managerList = employees?.map(
    (x: {
      employeenumber: number;
      fullname: string;
      email: string;
      status: string;
      firstname: string;
      middlename: string;
      lastname: string;
    }) => {
      return {
        id: x.employeenumber,
        value:
          x.firstname +
          (x.middlename ? " " + x.middlename + " " : " ") +
          x.lastname,
        label:
          x.firstname +
          (x.middlename ? " " + x.middlename + " " : " ") +
          x.lastname,
        email: x.email,
      };
    }
  );
  const managerEmail = employeeList?.filter(
    (a) => a.fullName == formMethods.watch("rslC")
  )[0]?.email;

  formMethods.setValue(
    "rslEmailC",
    managerEmail !== undefined ? managerEmail : null
  );
  const [isNoficationOnly, setIsNoficationOnly] = useState<boolean>(false);

  const isActionRequired = actionRequiredOpts
    ?.filter((a) => a.id === formMethods.watch("actionReqOrNotifId"))[0]
    ?.label?.toLowerCase()
    ?.includes("required");

  const isFullPayRequired = formMethods
    .watch("status")
    ?.toLowerCase()
    ?.includes("closed");

  const isCloseReason =
    formMethods.watch("status")?.toLowerCase()?.includes("80-closed") ||
    formMethods.watch("status")?.toLowerCase()?.includes("notified agent");

  return (
    <div className="bg-bgDB">
      <div className="m-2 bg-white box-shadow rounded-lg h-full">
        <div className="text-quinary font-bold font-sans py-2 px-4">
          Case Detail
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 mx-4 mr-5 pb-2 gap-12">
          <div className="space-y-1 mr-6">
            <Controller
              name="contactId"
              control={formMethods.control}
              rules={{ required: true }}
              render={({ field }) => (
                <SelectHookFormVirtualizeScorecard
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);
                    formMethods.setValue("contactEmail", e ? e?.email : null);
                    formMethods.setValue("contact", e ? e?.fullName : null);
                    formMethods.setValue(
                      "employeeStatusC",
                      e ? e?.status : null
                    );
                    formMethods.setValue("rslC", e ? e.manager : null);
                    if (e === null) {
                      formMethods.setValue("account", null);
                    }
                    if (!e.officeCode?.includes(",")) {
                      formMethods.setValue("account", e ? e?.officeName : null);
                    } else {
                      formMethods.setValue("account", null);
                    }
                    setEmpOfficeCode(e.officeCode);
                  }}
                  value={field.value}
                  options={
                    user.isFranchise && user.isNonFranchise
                      ? employeeList
                      : user.isFranchise
                      ? franchiseEmployee
                      : confieEmployee
                  }
                  label="Contact Name"
                  isLoading={empLoading}
                  className={
                    formMethods.formState.errors.contactId &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  required={true}
                />
              )}
            />
            <Controller
              name="account"
              control={formMethods.control}
              rules={{ required: true }}
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);
                    formMethods.setValue("account", e?.value);
                  }}
                  value={field.value}
                  defaultValue={sfOfficeNameOpt?.filter((x) =>
                    x.value?.includes(rowForEdit?.account)
                  )}
                  options={
                    isContact
                      ? accountOpts?.filter((x) =>
                          empOfficeCode?.includes(",")
                            ? empOfficeCode?.split(",")?.includes(x.id)
                            : empOfficeCode?.includes(x.id)
                        )
                      : []
                  }
                  label="Office Name"
                  className={
                    formMethods.formState.errors.account &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  required={true}
                />
              )}
            />
            <Controller
              name="typeId"
              control={formMethods.control}
              rules={{ required: true }}
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);
                    formMethods.setValue("type", e ? e.label : "");
                  }}
                  value={field.value}
                  options={typeOpts}
                  label="Type"
                  className={
                    formMethods.formState.errors.typeId &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  isLoading={isTypesLoading}
                  required={true}
                />
              )}
            />
            <Controller
              name="generalGroupId"
              control={formMethods.control}
              rules={{ required: true }}
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);
                    formMethods.setValue("generalGroupC", e ? e.label : "");
                    formMethods.setValue("descriptiveGroupId", null);
                    formMethods.setValue("scorecardAreaId", null);
                    formMethods.setValue("exceptionsC", null);
                  }}
                  value={field.value}
                  options={generalGroupOpts}
                  label="General Group"
                  className={
                    formMethods.formState.errors.generalGroupId &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  isLoading={isGenGroupLoading}
                  required={true}
                />
              )}
            />
            <Controller
              name="descriptiveGroupId"
              control={formMethods.control}
              rules={{ required: true }}
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);
                    formMethods.setValue("descriptiveGroupC", e ? e.label : "");
                    formMethods.setValue("scorecardAreaC", null);
                    formMethods.setValue("exceptionsC", null);
                  }}
                  value={field.value}
                  options={descGroupOpts ? descGroupOpts : []}
                  label="Descriptive Group"
                  className={
                    formMethods.formState.errors.descriptiveGroupId &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  isLoading={isDescGroupLoading}
                  required={true}
                />
              )}
            />

            <Controller
              control={formMethods.control}
              name="scorecardAreaId"
              rules={{ required: false }}
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);
                    formMethods.setValue("scorecardAreaC", e ? e.label : "");
                    formMethods.setValue("exceptionsC", null);
                  }}
                  value={field.value}
                  options={scoreCardAreaOpts ? scoreCardAreaOpts : []}
                  isLoading={isAreaScorecardLoading}
                  label="Scorecard Area"
                />
              )}
            />
            <Controller
              control={formMethods.control}
              name="exceptionsC"
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);
                  }}
                  value={field.value}
                  options={
                    exceptionFilteredOpts?.length > 0
                      ? exceptionFilteredOpts
                      : exceptionOpts
                  }
                  label="Exceptions"
                />
              )}
            />

            <TextInputLabelHookForm
              name="scorecardAreaOtherC"
              label="Scorecard Area (Other)"
              type="text"
              register={formMethods.register("scorecardAreaOtherC", {})}
              maxLength={255}
            />
            <TextInputLabelHookForm
              name="policyC"
              label="Policy Number"
              type="text"
              register={formMethods.register("policyC", {})}
              maxLength={100}
            />
            <TextInputLabelHookForm
              name="customerC"
              label="Customer Number"
              type="text"
              register={formMethods.register("customerC", {})}
              maxLength={10}
            />
            <NumericInputLabel
              name="amountC"
              label="Amount"
              register={register("amountC", {})}
              required={false}
              pattern="/^\d*\.?\d*$/i,"
              type="number"
              step="0.01"
              min="0"
              placeholder=""
              className={
                errors.amountC &&
                errors.amountC.message &&
                "border-2 border-red-500 col-span-2 "
              }
            />
            <TextInputLabelHookForm
              name="employeeStatusC"
              label="Employee Status"
              type="text"
              register={formMethods.register("employeeStatusC", {})}
              disabled={true}
            />
          </div>
          <div className="space-y-1">
            <TextInputLabelHookForm
              name="contactOwner"
              label="Case Owner"
              type="text"
              register={formMethods.register("contactOwner", {})}
              disabled={isAddState || isEditState}
            />
            <Controller
              name="statusId"
              control={formMethods.control}
              rules={{ required: true }}
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  isDisabled={isNoficationOnly}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);

                    formMethods.setValue("status", e ? e.label : "");
                    formMethods.setValue("closeReasonC", null);

                    if (e && e.value !== "80-Closed") {
                      formMethods.setValue("disputeC", "");
                      formMethods.setValue("fullPayC", null);
                    }
                  }}
                  value={field.value}
                  options={statusOpts}
                  label="Status"
                  className={
                    formMethods.formState.errors.statusId &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  isLoading={isStatusLoading}
                  required={true}
                />
              )}
            />
            <TextInputLabelHookForm
              name="suspendToC"
              label="Suspend To"
              type="date"
              register={formMethods.register("suspendToC", {})}
            />
            <Controller
              control={formMethods.control}
              name="closeReasonC"
              rules={{ required: isCloseReason }}
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);
                    formMethods.setValue("closeReasonC", e ? e?.value : null);
                  }}
                  value={field.value}
                  options={
                    closeReasonFilteredpOpts?.length > 0
                      ? closeReasonFilteredpOpts
                      : closeReasonpOpts
                  }
                  className={
                    formMethods.formState.errors.closeReasonC &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  label="Close Reason"
                  isDisabled={isCloseReason ? false : true}
                  required={isCloseReason}
                />
              )}
            />
            <NumericInputLabel
              name="writeOffAmountC"
              label="Write Off Amount"
              register={register("writeOffAmountC", {})}
              required={false}
              pattern="/^\d*\.?\d*$/i,"
              type="number"
              step="0.01"
              min="0"
              placeholder=""
              className={
                errors.writeOffAmountC &&
                errors.writeOffAmountC.message &&
                "border-2 border-red-500 col-span-2 "
              }
            />
            <CheckBoxHookForm_2
              name="isEscalated"
              label="Escalated"
              type="checkbox"
              validation={{
                required: {
                  value: false,
                  message: "Required Field",
                },
              }}
              hasPermission
              disabled={false}
              //required={false}
              className={
                formMethods.formState.errors.isEscalated &&
                formMethods.formState.errors.isEscalated.message &&
                "border-2 border-red-500 col-span-2 "
              }
              register={register}
            />
            <TextInputLabelHookForm
              name="contactEmail"
              label="Contact Email"
              type="email"
              register={formMethods.register("contactEmail", {})}
              disabled={true}
            />
            <Controller
              control={formMethods.control}
              name="rslC"
              rules={{ required: false }}
              render={({ field }) => (
                <SelectHookFormSingle
                  field={field}
                  onChange={(e) => {
                    field.onChange(e ? e.value : null);
                    formMethods.setValue("rslEmailC", e?.email);
                  }}
                  value={field.value}
                  options={managerList}
                  label="Manager"
                  isDisabled={true}
                />
              )}
            />
            <TextInputLabelHookForm
              name="rslEmailC"
              label="Manager Email"
              type="email"
              register={formMethods.register("rslEmailC", {})}
              disabled={true}
            />
            <CheckBoxHookForm_2
              name="agentUnknownC"
              label="Agent Unknown"
              type="checkbox"
              validation={{
                required: {
                  value: false,
                  message: "Required Field",
                },
              }}
              hasPermission
              disabled={false}
              register={register}
              // required={false}
              className={
                formMethods.formState.errors.agentUnknownC &&
                formMethods.formState.errors.agentUnknownC.message &&
                "border-2 border-red-500 col-span-2 "
              }
            />

            {isFullPayRequired && (
              <Controller
                name="fullPayC"
                control={formMethods.control}
                rules={{ required: isFullPayRequired }}
                render={({ field }) => (
                  <SelectHookFormSingle
                    field={field}
                    onChange={(e) => {
                      field.onChange(e ? e.value : null);
                      formMethods.setValue("fullPay", e ? e.value : null);
                    }}
                    value={field.value}
                    options={fullPayOpts}
                    label="Full Pay"
                    className={
                      formMethods.formState.errors.fullPayC &&
                      "border-2 border-red-500 col-span-2 "
                    }
                    required={isFullPayRequired}
                  />
                )}
              />
            )}
            {isDisputeRequired && (
              <Controller
                control={formMethods.control}
                name="disputeId"
                rules={{ required: false }}
                render={({ field }) => (
                  <SelectHookFormSingle
                    field={field}
                    onChange={(e) => {
                      field.onChange(e ? e.value : 0);
                      formMethods.setValue("disputeC", e ? e?.label : null);
                    }}
                    value={field.value}
                    options={disputeOpts}
                    label="Dispute"
                  />
                )}
              />
            )}
            {isEditState && (
              <CheckBoxHookForm_2
                name="isActive"
                label="Is Active"
                type="checkbox"
                validation={{
                  required: {
                    value: false,
                    message: "Required Field",
                  },
                }}
                hasPermission
                disabled={false}
                register={register}
                // required={false}
                className={
                  formMethods.formState.errors.isActive &&
                  formMethods.formState.errors.isActive.message &&
                  "border-2 border-red-500 col-span-2 "
                }
              />
            )}
          </div>
        </div>
      </div>
      <div className="flex flex-cols-2">
        <div
          className={`ml-2 mr-2 ${
            !isAddState ? "w-1/2" : "w-full"
          } bg-white box-shadow rounded-lg`}
        >
          <div className="text-quinary font-bold font-sans py-2 px-4">
            Description Information
          </div>
          <div
            className={`${
              !isAddState
                ? "grid grid-cols-1 md:grid-cols-1 mr-10 mx-4 py-2 gap-12"
                : "grid grid-cols-1 md:grid-cols-2 mr-10 mx-4 py-2 gap-12"
            }`}
          >
            <div className="space-y-1 mr-2">
              <TextInputLabelHookForm
                name="subject"
                label="Subject"
                type="text"
                required={true}
                className={
                  formMethods.formState.errors.subject &&
                  formMethods.formState.errors.subject.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("subject", {
                  required: {
                    value: true,
                    message: "Required Field",
                  },
                })}
                maxLength={255}
              />
              {isEditState ? (
                <Controller
                  name="actionReqOrNotifId"
                  control={formMethods.control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <SelectHookFormSingle
                      field={field}
                      onChange={(e) => {
                        field.onChange(e ? e.value : null);
                        formMethods.setValue(
                          "actionRequiredOrNotificationC",
                          e?.label
                        );
                        formMethods.setValue("closeReasonC", null);

                        if (e && e.label === "Notification Only") {
                          setIsNoficationOnly(true);
                          formMethods.setValue(
                            "status",
                            "81-Notified Agent and Closed"
                          );
                          formMethods.setValue("statusId", 7);
                          formMethods.setValue("actionToTakeC", null);
                        } else {
                          setIsNoficationOnly(false);
                        }
                        if (e && e.label === "Action Required") {
                          formMethods.setValue("status", null);
                          formMethods.setValue("statusId", 0);
                          setIsNoficationOnly(false);
                        }
                      }}
                      value={field.value}
                      options={actionRequiredOpts}
                      label="Action Required Or Notification"
                      className={
                        formMethods.formState.errors.actionReqOrNotifId &&
                        "border-2 border-red-500 col-span-2 "
                      }
                      required={true}
                      isDisabled={false}
                    />
                  )}
                />
              ) : (
                <Controller
                  name="actionReqOrNotifId"
                  control={formMethods.control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <SelectHookFormSingle
                      field={field}
                      onChange={(e) => {
                        formMethods.setValue(
                          "actionRequiredOrNotificationC",
                          e?.label
                        );
                        formMethods.setValue("closeReasonC", null);
                        formMethods.setValue("status", null);
                        formMethods.setValue("statusId", null);
                        field.onChange(e ? e.value : null);
                        if (e?.label === "Notification Only") {
                          formMethods.setValue(
                            "status",
                            "81-Notified Agent and Closed"
                          );
                          setIsNoficationOnly(true);
                          formMethods.setValue("actionToTakeC", null);
                          formMethods.setValue("statusId", 7);
                        }
                        if (e?.label === "Action Required") {
                          formMethods.setValue("status", "01-New");
                          formMethods.setValue("statusId", 1);
                          setIsNoficationOnly(false);
                        }
                      }}
                      value={field.value}
                      isLoading={ActionRequiredLoading}
                      options={actionRequiredOpts}
                      label="Action Required Or Notification"
                      className={
                        formMethods.formState.errors.actionReqOrNotifId &&
                        "border-2 border-red-500 col-span-2 "
                      }
                      required={true}
                    />
                  )}
                />
              )}

              <TextInputLabelHookForm
                name="actionToTakeC"
                label="Action To Take"
                type="text"
                required={isActionRequired}
                className={
                  formMethods.formState.errors.actionToTakeC &&
                  formMethods.formState.errors.actionToTakeC.message &&
                  "border-2 border-red-500 col-span-2 "
                }
                register={formMethods.register("actionToTakeC", {
                  required: {
                    value: isActionRequired,
                    message: "Required Field",
                  },
                })}
                disabled={isActionRequired ? false : true}
                maxLength={255}
              />
            </div>
          </div>
        </div>
        {!isAddState && (
          <div className="mr-2 w-1/2 bg-white box-shadow rounded-lg">
            <div className="text-quinary font-bold font-sans py-2 px-4">
              System Information
            </div>
            <div className="grid grid-cols-1 md:grid-cols-1 mr-5 mx-4 py-2 space-y-1">
              <div className="space-y-1">
                <TextInputLabelHookForm
                  name="createdDate"
                  label="Date/Time Opened"
                  type="date"
                  required={false}
                  className={
                    formMethods.formState.errors.createdDate &&
                    formMethods.formState.errors.createdDate.message &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  register={formMethods.register("createdDate", {
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  })}
                  disabled={true}
                />
              </div>
              <div className="space-y-1">
                <TextInputLabelHookForm
                  name="closedDate"
                  label="Date/Time Closed"
                  type="date"
                  required={false}
                  className={
                    formMethods.formState.errors.closedDate &&
                    formMethods.formState.errors.closedDate.message &&
                    "border-2 border-red-500 col-span-2 "
                  }
                  register={formMethods.register("closedDate", {
                    required: {
                      value: false,
                      message: "Required Field",
                    },
                  })}
                  disabled={true}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScoreCardDetails;
